module.exports = __webpack_public_path__ + "static/media/img_8.9c4699ab.JPG";